// extracted by mini-css-extract-plugin
module.exports = {"answerOptionList":"AnswerOptionList_answerOptionList__1cqTY","first":"AnswerOptionList_first__1Mk-t"};